import {FaLinkedinIn, FaGithubAlt, FaFacebookF } from "react-icons/fa";
export const contactLinks = [
    {
        id: 1,
        links: "https://www.linkedin.com/in/md-niamul-hakim-936948239/",
        icon: <FaLinkedinIn />,
        classes: "blue"
    },
    {
        id: 2,
        links: "https://github.com/shawn102",
        icon: <FaGithubAlt />,
        classes: "black"
    },
    {
        id: 3,
        links: "https://www.facebook.com/niamul102",
        icon: <FaFacebookF />,
        classes: "lightblue"
    }
];
